import { TulipPanelWidget } from "./widget/TulipPanelWidget";
import { CocosConstants } from "../../constants";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { GUIConstants } from "../../cocos/scripts/utils/GUIConstants";
import { ActionStateEnum } from "../../cocos/scripts/state/actionState/ActionState";
import { AreaState, FrontViewCoating } from "../../cocos/scripts/state";
import { AreaStateEditModeEnum } from "../../cocos/scripts/state";
import { PlanManager } from "../../cocosPlan";
import { ArrangementGroup, ArrangementObject, Commands, ComponentConstants, Entity, Events, eventsManager, Functionality, GeometryPrimitive, HttpService, Joinery, JoineryType, SceneConstants, Staircase, TechnicalElement } from "@rhinov/savane-js";



export class PetalsTabController {

    tulipItem: Entity | (Entity[] & { entityType?: string });
    urlconfig: string;
    user: any;
    openAssetDetailCallback: CallableFunction;
    deliverable: any;
    designer: any;
    panelConf: any = null;
    openedPanel: string | null = null;
    tulipPlanPosition: any;
    

    //Tulip item init
    panel: any = null;
    dropdown: boolean = false; //FIXME this may need a refacto, generic param for a particular func ?
    petals: Array<any> = [];
    mainFunctionality: any = null;
    //SRC
    cocheSrc: string = CocosConstants.resourcesBasePath + '/resources/coche.png';

    functionalities: any= TulipAssetConstant.getinstance().getfunctionalities();
    dropdownData: Array<{ id: number, name: string, model: string}> = [];
    _subListDecal: number = 0;
    _subListLength: number = 4;
    tulipPanelWidget: TulipPanelWidget | null = null;

    //Load config file
    tulipConfig: any = null;

    constructor (tulipItem: Entity, urlconfig: string, openAssetDetailCallback: CallableFunction, deliverable: any, user: any, _designer: any, callback: CallableFunction) {
        this.tulipItem = tulipItem;
        this.urlconfig = urlconfig;
        this.user = user;
        this.openAssetDetailCallback = openAssetDetailCallback;
        this.deliverable = deliverable;
        this.setTulipConfig(() => {
            this.tulipItemListener();
            callback();
        })
    }

    updateJoineryProperties() {
        switch ((this.tulipItem as Joinery).joineryType) {
            case SceneConstants.JoineryType.door:
            case SceneConstants.JoineryType.frontDoor:
            case SceneConstants.JoineryType.window:
            case SceneConstants.JoineryType.frenchWindow:
            case SceneConstants.JoineryType.pictureWindow:
            case SceneConstants.JoineryType.fixedWindow:
            case SceneConstants.JoineryType.canopy:
            case SceneConstants.JoineryType.cupboardDoor:
            case SceneConstants.JoineryType.garageDoor:
            case SceneConstants.JoineryType.niche:
                this.updateCommonJoineryProperties();
                this.updateComplexJoineryProperties();
                break;
            case SceneConstants.JoineryType.velux:
            case SceneConstants.JoineryType.opening:
                this.updateCommonJoineryProperties();
                break;
        }
    }

    updateComplexJoineryProperties() {
        var slideOpening = false;
        var multiDoors = (this.tulipItem as any).nbDoors > 1 || (this.tulipItem as any).nbCasement > 1;

        // Set if element is slide element or not
        if ((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.frenchWindow) {
            slideOpening = (this.tulipItem as any)[GUIConstants.OPENING_MODE] !== SceneConstants.OpeningMode.mode_default;
        }
        // Set if door open inside or outside the room
        var openingOrientation = document.querySelector('.' + GUIConstants.OPENING_ORIENTATION + ' span');
        if (openingOrientation) {
            if ((this.tulipItem as any)[GUIConstants.OPENING_ORIENTATION] === true) {
                // console.log('Add checked attribute');
                openingOrientation.classList.remove('icon-Tulip_OpenningUp');
                openingOrientation.classList.add('icon-Tulip_OpenningDown');
            } else {
                //console.log('Remove checked attribute');
                openingOrientation.classList.remove('icon-Tulip_OpenningDown');
                openingOrientation.classList.add('icon-Tulip_OpenningUp');
            }
        }

        // Set handleside
        var hingesPosition = document.querySelector('.' + GUIConstants.HINGES_POSITION + ' span');
        if (hingesPosition){
            if ((this.tulipItem as any)[GUIConstants.HINGES_POSITION] === SceneConstants.HandleSide.handle_left) {
                hingesPosition.classList.remove('icon-Tulip_HandleRight');
                hingesPosition.classList.add('icon-Tulip_HandleLeft');
            } else {
                hingesPosition.classList.remove('icon-Tulip_HandleLeft');
                hingesPosition.classList.add('icon-Tulip_HandleRight');
            }
        }
        openingOrientation = document.querySelector('.' + GUIConstants.OPENING_ORIENTATION)
        if (openingOrientation) {
            openingOrientation.classList.remove('hide');
            var next = openingOrientation.nextElementSibling;
            if (next) {
                next.classList.remove('hide');
            }
        }

        hingesPosition = document.querySelector('.' + GUIConstants.HINGES_POSITION);
        if (slideOpening) {
            //$('.' + GUIConstants.OPENING_ORIENTATION).addClass('hide').next().addClass('hide');
            //$('.' + GUIConstants.HINGES_POSITION).addClass('hide').next().addClass('hide');
            var openingRight = document.querySelector('.' + GUIConstants.OPENING_RIGHT_ORIENTATION);
            if (openingRight) {
                openingRight.classList.remove('hide');
                var next = openingRight.nextElementSibling;
                if (next) {
                    next.classList.remove('hide');
                }
            }
        } else {
            var openingRight = document.querySelector('.' + GUIConstants.OPENING_RIGHT_ORIENTATION);
            if (openingRight) {
                openingRight.classList.add('hide');
                var next = openingRight.nextElementSibling;
                if (next) {
                    next.classList.add('hide');
                }
            }

            if (hingesPosition) {
                hingesPosition.classList.remove('hide');
                var next = hingesPosition.nextElementSibling;
                if (next) {
                    next.classList.add('hide');
                }
            }
        }

        if (multiDoors) {
            if (hingesPosition) {
                hingesPosition.classList.add('hide');
                var next = hingesPosition.nextElementSibling;
                if (next) {
                    next.classList.add('hide');
                }
            }
        }
        else {
            if (((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.fixedWindow) &&
                ((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.velux) &&
                ((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.canopy) &&
                ((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.garageDoor) &&
                ((this.tulipItem as Joinery).joineryType !== SceneConstants.JoineryType.niche)) {
                if (hingesPosition) {
                    hingesPosition.classList.remove('hide');
                    var next = hingesPosition.nextElementSibling;
                    if (next) {
                        next.classList.remove('hide');
                    }
                }
            }
            else {
                if (hingesPosition) {
                    hingesPosition.classList.add('hide');
                    var next = hingesPosition.nextElementSibling;
                    if (next) {
                        next.classList.add('hide');
                    }
                }
            }
        }
    };

    updateCommonJoineryProperties() {
        var openingOrientation = document.querySelector('.' + GUIConstants.OPENING_ORIENTATION);
        if (openingOrientation) {
            openingOrientation.classList.add('hide');
            var next = openingOrientation.nextElementSibling;
            if (next) {
                next.classList.add('hide');
            }
        }

        var hingesPosition = document.querySelector('.' + GUIConstants.HINGES_POSITION);
        if (hingesPosition) {
            hingesPosition.classList.add('hide');
            var next = hingesPosition.nextElementSibling;
            if (next) {
                next.classList.add('hide');
            }
        }
    };

    DispatchEvent(petal: any) {
        eventsManager.instance.dispatch((Events as any)[petal.event], this.tulipItem);
    };

    //front view
    showFrontView() {
        var wall = null;

        if (PlanManager.getInstance().selectedEntities.length === 1 &&
            PlanManager.getInstance().selectedEntities[0].entityType === SceneConstants.EntityType.Wall) {
            wall = PlanManager.getInstance().selectedEntities[0];

            eventsManager.instance.dispatch(Events.OPEN_FRONT_VIEW, wall);
            PlanManager.getInstance().switchToFrontViewMode(wall as any);

            var container = document.getElementById('superGame');
            if (PlanManager.getInstance().frontViewLayer.isVisible() && container) {
                PlanManager.getInstance().frontViewLayer.resize(container.clientWidth, container.clientHeight);
            }
        }
    };

    rotateArrangementLeft() {
        var entity = PlanManager.getInstance().selectedEntities[0];
        if (PlanManager.getInstance().selectedEntities.length === 1 &&
            (entity.entityType === SceneConstants.EntityType.ArrangementObject ||
                entity.entityType === SceneConstants.EntityType.ArrangementGroup ||
                entity.entityType === SceneConstants.EntityType.GeometryGroup ||
                entity.entityType === SceneConstants.EntityType.RenderCamera)) {
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "angle",
                value: entity.angle + (Math.PI / 2),
                obj: this.tulipItem
            });
        }
    };

    rotateArrangementRight() {
        var entity = PlanManager.getInstance().selectedEntities[0];
        if (PlanManager.getInstance().selectedEntities.length === 1 &&
            (entity.entityType === SceneConstants.EntityType.ArrangementObject ||
                entity.entityType === SceneConstants.EntityType.ArrangementGroup ||
                entity.entityType === SceneConstants.EntityType.GeometryGroup ||
                entity.entityType === SceneConstants.EntityType.RenderCamera)) {
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "angle",
                value: entity.angle - (Math.PI / 2),
                obj: this.tulipItem
            });
        }
    };

    rotateStaircaseLeft() {
        var entity = PlanManager.getInstance().selectedEntities[0];
        if (PlanManager.getInstance().selectedEntities.length === 1 &&
            entity.isStaircaseEntity()) {
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "angle",
                value: entity.angle + (Math.PI / 2),
                obj: this.tulipItem
            });
        }
    };

    rotateStaircaseRight() {
        var entity = PlanManager.getInstance().selectedEntities[0];
        if (PlanManager.getInstance().selectedEntities.length === 1 &&
            entity.isStaircaseEntity()) {
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "angle",
                value: entity.angle - (Math.PI / 2),
                obj: this.tulipItem
            });
        }
    };

    DeleteElement() {
        //TODO add the element to delete !
        eventsManager.instance.dispatch(Events.DELETE_EVENT);
    };

    CopyElement() {
        PlanManager.getInstance().duplicateElement([this.tulipItem as Entity]);
        //FIXME Fire an event to hide tulip ?
        //this.hideTulip();
    };

    //FIXME This should pass by dispatch event ?
    StaircaseWayFunction() {
        let element =  document.querySelector('.staircaseWay span');
        if (!element) return;
        eventsManager.instance.dispatch(Events.SLIDER_BUTTON, {
            editedProperty: 'way',
            value: element.getAttribute('stair-way') === 'true' ? false : true,
            obj: this.tulipItem
        });
    };
    //FIXME This should pass by dispatch event ?
    OrientationFunction() {
        eventsManager.instance.dispatch(Events.SLIDER_BUTTON, {
            editedProperty: 'orientation',
            value: !(this.tulipItem as any)['orientation'],
            obj: this.tulipItem
        });
    };
    //FIXME This should pass by dispatch event ?
    StaircaseGoingUpFunction() {
        var bool = true;
        let element =  document.querySelector('.staircaseUp span');
        if (!element) return;
        if (element.classList.contains('icon-Tulip_OpenningDown')) {
            bool = false;
        }
        eventsManager.instance.dispatch(Events.SLIDER_BUTTON, {
            editedProperty: 'isGoingDown',
            value: bool,
            obj: this.tulipItem
        });
    };
    //FIXME This should pass by dispatch event ?
    HandleSideFunction() {
        var bool = true;
         let element =  document.querySelector('.handleSide span');
        if (!element) return;
        if (element.classList.contains('icon-Tulip_HandleRight')) {
            bool = false;
        }
        eventsManager.instance.dispatch(Events.SLIDER_BUTTON, {
            editedProperty: 'handleSide',
            value: bool,
            obj: this.tulipItem
        });
    };

    petalFunction(petal: any) {
        (this as any)[petal.func](petal);
        document.getElementById("gameCanvas")?.focus();
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
    };

    isLastNotHidden(petal: any, petals: any) {
        var i;

        for (i = 0; i < petals.length; i++) {
            if (petals[i] === petal) {
                i++;
                break;
            }
        }

        for (; i < petals.length; i++) {
            if (!this.hidePetal(petals[i])) {
                return (false);
            }
        }

        return (true);
    };

    hidePetal = (petal: any) => {
        if (PlanManager.getInstance().frontViewLayer.isVisible() && petal.hideInFrontView) {
            return (true);
        }
        if (!PlanManager.getInstance().frontViewLayer.isVisible() && petal.hideInTopView) {
            return (true);
        }
        return (false);
    };

    setDropdownProperty(element: any) {
        var index = this.dropdownData.findIndex((item) => {
            return item.id === (element - 0);
        });
        if ((this.tulipItem as Entity).isRoomEntity()) { 
            if (index !== -1) {
                this.mainFunctionality = this.dropdownData[index].id;
                //this.generateSecondaryFuncList(this.mainFunctionality);

                eventsManager.instance.dispatch(Events.MAINFUNCTIONALITY_CHANGE, {
                    data: this.dropdownData[index],
                    room: this.tulipItem
                });

                // Tutorial start
                eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 21);
                // End tutorial
            }
        } else if ((this.tulipItem as Entity).isJoineryEntity()) {
            (this.tulipItem as Entity).startTemporary();
            (this.tulipItem as Joinery).joineryType = (element - 0);
            let components = (this.tulipItem as Entity).getComponents(ComponentConstants.ComponentType.JoineryType) as JoineryType[];
            if (components.length > 0) {
                components[0].joineryTypeId = this.dropdownData[index].model;
            }
            PlanManager.getInstance().executeCommand(new Commands.EditJoineryCommand(this.tulipItem as Joinery));
        }

        if (index !== -1) {
            let drop_down = document.getElementById('dropdownValue') as HTMLInputElement;
            if (drop_down) {
                drop_down.innerHTML = '<h class=\'dropdownButton\'>' + this.dropdownData[index].name + '</h> <span class=\'caret\'></span>';
                drop_down.value = this.dropdownData[index].id.toString();
            }
        }
    };

    generateDropdownData() {
        if (!this.tulipItem) return;

        this.dropdownData = [];
        if ((this.tulipItem as Entity).isRoomEntity()) {
            if (this.functionalities && this.functionalities.length > 0) {
                for (var i = 0; i < this.functionalities.length; i++) {
                    this.dropdownData.push(this.functionalities[i]);
                }
            }
        } else if ((this.tulipItem as Entity).isJoineryEntity()) {
            this.dropdownData = [
                {id: SceneConstants.JoineryType.door, name: "Porte", model: SceneConstants.DefaultJoineryType.door},
                {id: SceneConstants.JoineryType.frontDoor, name: "Porte d'entrée", model: SceneConstants.DefaultJoineryType.frontDoor},
                {id: SceneConstants.JoineryType.window, name: "Fenêtre", model: SceneConstants.DefaultJoineryType.window},
                {id: SceneConstants.JoineryType.frenchWindow, name: "Porte fenêtre", model: SceneConstants.DefaultJoineryType.frenchWindow},
                {id: SceneConstants.JoineryType.pictureWindow, name: "Baie vitrée", model: SceneConstants.DefaultJoineryType.pictureWindow},
                {id: SceneConstants.JoineryType.canopy, name: "Verrière", model: SceneConstants.DefaultJoineryType.canopy},
                {id: SceneConstants.JoineryType.opening, name: "Ouverture", model: SceneConstants.DefaultJoineryType.opening},
                {id: SceneConstants.JoineryType.cupboardDoor, name: "Placard", model: SceneConstants.DefaultJoineryType.cupboardDoor},
                {id: SceneConstants.JoineryType.garageDoor, name: "Porte de garage", model: SceneConstants.DefaultJoineryType.garageDoor},
                {id: SceneConstants.JoineryType.niche, name: "Niche", model: SceneConstants.DefaultJoineryType.niche},
                {id: SceneConstants.JoineryType.fixedWindow, name: "Châssis fixe", model: SceneConstants.DefaultJoineryType.fixedWindow}
            ].sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }
    };

    isDropdownValueActive = (value: any) => {
        var dropdown = document.getElementById('dropdownValue') as HTMLInputElement;
        if (!dropdown) return false;
        if (value === dropdown.value) {
            return true;
        }
    
        return false;
    };

    updatePropertiesElement() {
        switch (this.tulipItem.entityType) {
            case SceneConstants.EntityType.Room:
                this.updateRoomProperties();
                break;
            case SceneConstants.EntityType.Joinery:
                this.updateJoineryProperties();
                var index = this.dropdownData.findIndex((item) => {
                    return item.id === (this.tulipItem as Joinery).joineryType;
                });
                if (index !== -1) {
                    var dropDown = document.getElementById('dropdownValue') as HTMLInputElement;
                    if (dropDown) {
                        dropDown.innerHTML = '<h class=\'dropdownButton\'>' + this.dropdownData[index].name + '</h> <span class=\'caret\'></span>';
                        dropDown.value = (this.tulipItem as Joinery).joineryType.toString();
                    }
                }
                break;
            case SceneConstants.EntityType.Staircase:
                this.updateStaircaseProperties();
                break;
            case SceneConstants.EntityType.ArrangementGroup:
            case SceneConstants.EntityType.ArrangementObject:
                this.updatePropertiesArrangement();
                break;

            case '*':
                var hide = false;
                var valid = 0;
                for (var i = 0 ; i < this.tulipItem.length ; i++) {
                    if (!((this.tulipItem[i].isArrangementGroupEntity() && (this.tulipItem[i] as ArrangementGroup).isUnbreakableGroup()) || this.tulipItem[i].isGeometryGroupEntity() || this.tulipItem[i].isGeometryPrimitiveEntity())) {
                        valid++;
                    }
                }
                if (valid < 2) {
                    hide = true;
                }
                if (hide) {
                    var bar = document.getElementById('Grouper-div');
                    var merge = document.querySelector('.merge');
                    if (merge && bar) {
                        bar.classList.add('hide');
                        var next = merge.nextElementSibling;
                        if (next) {
                            next.classList.add('hide');
                        }
                        merge.classList.add('hide');
                    }
                }
                break;
        }
    };

    updateRoomProperties() {
        var functionalityComponent = (this.tulipItem as Entity).getComponent(ComponentConstants.ComponentType.Functionality) as Functionality;
        //Update func value in this
        if (functionalityComponent !== null) {
            this.mainFunctionality = functionalityComponent.functionalityId;
        }
        var dropDown = document.getElementById('dropdownValue') as HTMLInputElement;
        if (dropDown) {
            dropDown.innerHTML = '<h class=\'dropdownButton\'>' + ((functionalityComponent.functionalityName === '' || functionalityComponent.functionalityName === null) ? 'Choisir' : functionalityComponent.functionalityName) + '</h> <span class=\'caret\'></span>';
            dropDown.value = String(functionalityComponent.functionalityId);
        }
    };

    updateStaircaseProperties() {
        var staircaseup = document.querySelector('.staircaseUp' + ' span');
        if (staircaseup) {
            if ((this.tulipItem as Staircase).isGoingDown === true) {
                // console.log('Add checked attribute');
                staircaseup.classList.remove('icon-Tulip_OpenningUp');
                staircaseup.classList.add('icon-Tulip_OpenningDown');
            } else {
                staircaseup.classList.remove('icon-Tulip_OpenningDown');
                staircaseup.classList.add('icon-Tulip_OpenningUp');
            }
        }
        var staircaseWay = document.querySelector('.staircaseWay span');
        if (staircaseWay) {
            staircaseWay.setAttribute('stair-way', (this.tulipItem as Staircase).way ? 'true' : 'false');
        }
    };

    updatePropertiesArrangement() {
        var hide = true;
        var tulipItem = this.tulipItem as Entity
        if (tulipItem.parent !== null &&
            (tulipItem.parent.entityType === SceneConstants.EntityType.Floor || tulipItem.parent.entityType === SceneConstants.EntityType.Room)) {
            hide = true;
        } else {
            hide = false;
        }
        var del = document.querySelector('.delete');
        var copy = document.querySelector('.copy');
        if (del && copy) {
            var nextdel = del.nextElementSibling;
            var copynext = copy.nextElementSibling;
            if ((tulipItem.parent !== null) && tulipItem.parent.isArrangementGroupEntity() && (tulipItem.parent as ArrangementGroup).isUnbreakableGroup()) {
                hide = true;
                del.classList.add('hide');
                if (nextdel) {
                    nextdel.classList.add('hide');
                }
                copy.classList.add('hide');
                if (copynext) {
                    copynext.classList.add('hide');
                }
            }
            else {
                del.classList.remove('hide');
                if (nextdel) {
                    nextdel.classList.remove('hide');
                }
                copy.classList.remove('hide');
                if (copynext) {
                    copynext.classList.remove('hide');
                };
            }
        }
        var group = document.querySelector('.ungroup_me');
        if (group) {
            var next = group.nextElementSibling;
            if (hide) {
                group.classList.add('hide');
                if (next) {
                    next.classList.add('hide');
                }
            } else {
                group.classList.remove('hide');
                if (next) {
                    next.classList.remove('hide');
                }    
            }
        }

        var children = tulipItem.getChildren([SceneConstants.EntityType.ArrangementGroup, SceneConstants.EntityType.ArrangementObject], null);
        hide = true;

        for (var i = 0; i < children.length; i++) {
            if (!children[i].isGhost()) {
                hide = false;
                break;
            }
        }

        if (tulipItem.isArrangementGroupEntity() && (this.tulipItem as ArrangementGroup).isUnbreakableGroup()) {
            hide = true;
            var save = document.querySelector('.save');
            if (save) {
                var nextsave = save.nextElementSibling;
                save.classList.add('hide');
                if (nextsave) {
                    nextsave.classList.add('hide');
                }
            }
        }
        else {
            var save = document.querySelector('.save');
            if (save) {
                var nextsave = save.nextElementSibling;
                save.classList.remove('hide');
                if (nextsave) {
                    nextsave.classList.remove('hide');
                }
            }
        }
        group = document.querySelector('.ungroup');
        if (group) {
            var next = group.nextElementSibling;
            if (hide) {
                group.classList.add('hide');
                if (next) {
                    next.classList.add('hide');
                }
            } else {
                group.classList.remove('hide');
                if (next) {
                    next.classList.remove('hide');
                }    
            }
        }
    }

    CopyCoatinArea(_params: any) {
        var tulipItem = this.tulipItem as Entity
        var comp = tulipItem.getComponents(ComponentConstants.ComponentType.CoatingArea);

        if (comp.length > 0) {
            if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                var state = PlanManager.getInstance().state as unknown as AreaState;

                if (state.state === ActionStateEnum.FrontViewCoating) {
                    var copiedCoatingArea = state._area!.clone();

                    tulipItem.addComponent(copiedCoatingArea);
                    eventsManager.instance.dispatch(Events.HIDE_TULIP);
                    PlanManager.getInstance().frontViewLayer.renderCurrentWall();

                    // Here go to edit coating area
                    var cursorPosition = (PlanManager.getInstance()._state as unknown as FrontViewCoating)._originalCursorPosition;
                    PlanManager.getInstance()._state.dispose();
                    PlanManager.getInstance()._state = new FrontViewCoating(copiedCoatingArea, AreaStateEditModeEnum.area_selected, cursorPosition) as any;
                }
            }
        }
    };

    setTulipConfig(callback: any) {
        if (this.urlconfig && this.urlconfig !== null) {
            HttpService.get(this.urlconfig)
                .then(
                    (response: any) => {
                        this.tulipConfig = response.data;
                        callback();
                    },
                    () => {
                        console.error('Can\'t find tulip config file');
                    }
                );
        } else {
            console.error('Can\'t find tulip config file');
        }
    }

    showTab(petal: any) {
        //If already selected, just close the tab
        if (this.openedPanel === petal.tab) {
            this.openedPanel = null;
            this.panelConf = null;
        } else {
            //Retrieve tab
            this.openedPanel = petal.tab;
            this.panelConf = petal;    //rouleaux entry
        }

        if (!this.tulipPanelWidget) {
            this.tulipPanelWidget = new TulipPanelWidget(this);
        } else {
            this.tulipPanelWidget.destroy();
            this.tulipPanelWidget = new TulipPanelWidget(this);
        }
    };

    hideTab() {
        if (this.tulipPanelWidget) {
            this.tulipPanelWidget.destroy();
            this.tulipPanelWidget = null;
        }
        this.openedPanel = null;
    };

    tulipItemListener() {
        this.hideTab();
        // Store plan coordinates where the tulip is opened
        this.tulipPlanPosition = PlanManager.getInstance()._uiState.cursorPosition;
        if (this.tulipItem === null || this.tulipItem === undefined) {
            //Leave func if item is null
            this.petals = [];
        } else {
            //Handle the multi select ?
            if (Array.isArray(this.tulipItem)) {
                if (!this.tulipItem[0].isArrangementGroupEntity() && !this.tulipItem[0].isArrangementObjectEntity() &&
                    !this.tulipItem[0].isGeometryGroupEntity() && !this.tulipItem[0].isGeometryPrimitiveEntity()) {
                    eventsManager.instance.dispatch(Events.HIDE_TULIP);
                    return;
                }

                this.tulipItem.entityType = '*';
            }
            //Init petal list
            var petalsList = [];
            this.dropdown = false;
            if (this.tulipConfig.tulips[this.tulipItem.entityType!] !== undefined) {
                var petalsData = this.tulipConfig.tulips[this.tulipItem.entityType!].petals;
                //Extract petals from config
                for (var petal in petalsData) {
                    //Test validity of petal
                    if (petalsData[petal].componentType !== undefined) {
                        //Check that:
                        //  -isn't multiselection FIXME Maybe handle component for multi select
                        //  -component is in entity
                        if (this.tulipItem.entityType !== '*' &&
                            (this.tulipItem as Entity).getComponent(petalsData[petal].componentType) !== null) {
                            petalsList.push(petalsData[petal]);
                        }

                    } else {
                        petalsList.push(petalsData[petal]);
                    }
                }
                this.dropdown = this.tulipConfig.tulips[this.tulipItem.entityType!].hasDropdown;
                if (this.tulipItem.entityType === SceneConstants.EntityType.Joinery && (this.tulipItem as Joinery).joineryType === SceneConstants.JoineryType.velux) {
                    this.dropdown = false;
                }
                //Check if tulip is empty
                if (petalsList.length <= 0 && this.dropdown === undefined) {
                    eventsManager.instance.dispatch(Events.HIDE_TULIP);
                    return;
                }
            } else {
                eventsManager.instance.dispatch(Events.HIDE_TULIP);
                return;
            }

            this.petals = petalsList;
            //Init properties panel
            this.panel = null;
            var propertiesPanels = this.tulipConfig.propertiesPanels;
            var key = this.getKey();
            for (var i = 0; i < propertiesPanels.length; i++) {
                if (propertiesPanels[i].key === key) {
                    //Found corresponding panel
                    this.panel = propertiesPanels[i];
                    break;
                }
            }
            // Called later than previously because this wasn't hidding the unecessary options.
            if (this.tulipItem.entityType === SceneConstants.EntityType.Room || this.tulipItem.entityType === SceneConstants.EntityType.Joinery) {
                this.generateDropdownData();
            }
            return true;
        };
    }

    getKey() {
        var key = '';
        if (this.tulipItem === null) {
            //No item in tulip
            return null;
        }
        switch (this.tulipItem.entityType) {
            case '*':
                //FIXME An error may occur here
                //Multiple selection
                key = 'MutlipleEntities';
                break;
            case SceneConstants.EntityType.RenderCamera:
                key = 'RenderCamera';
                break;
            case SceneConstants.EntityType.Comment:
                key = 'Comment';
                break;
            case SceneConstants.EntityType.ArrangementObject:
                if ((this.tulipItem as ArrangementObject).stretchability) {
                    key = 'StretchableArrangement';
                }
                else {
                    key = 'Arrangement';
                }
                break;
            case SceneConstants.EntityType.ArrangementGroup:
                key = 'ArrangementGroup';
                break;
            case SceneConstants.EntityType.GeometryGroup:
                key = 'GeometryGroup';
                break;
            case SceneConstants.EntityType.Wall:
                key = 'Wall';
                break;
            case SceneConstants.EntityType.Room:
                key = 'Room';
                break;
            case SceneConstants.EntityType.Sun:
                key = 'Sun';
                break;
            case SceneConstants.EntityType.Joinery:
                switch ((this.tulipItem as Joinery).joineryType) {
                    case SceneConstants.JoineryType.door:
                        key = 'Door';
                        break;
                    case SceneConstants.JoineryType.frontDoor:
                        key = 'FrontDoor';
                        break;
                    case SceneConstants.JoineryType.window:
                        key = 'WindowJoinery';
                        break;
                    case SceneConstants.JoineryType.opening:
                        key = 'Opening';
                        break;
                    case SceneConstants.JoineryType.fixedWindow:
                        key = 'FixedWindow';
                        break;
                    case SceneConstants.JoineryType.velux:
                        key = 'Velux';
                        break;
                    case SceneConstants.JoineryType.canopy:
                        key = 'Canopy';
                        break;
                    case SceneConstants.JoineryType.cupboardDoor:
                        key = 'CupboardDoor';
                        break;
                    case SceneConstants.JoineryType.garageDoor:
                        key = 'GarageDoor';
                        break;
                    case SceneConstants.JoineryType.frenchWindow:
                        key = 'FrenchWindow';
                        break;
                    case SceneConstants.JoineryType.pictureWindow:
                        key = 'DoorWindow';
                        break;
                    case SceneConstants.JoineryType.niche:
                        key = 'Niche';
                        break;
                }
                break;
            case SceneConstants.EntityType.GeometryPrimitive:
                switch ((this.tulipItem as GeometryPrimitive).primitiveType) {
                    case SceneConstants.GeometryPrimitiveType.box:
                        key = 'Box';
                        break;
                    case SceneConstants.GeometryPrimitiveType.cylinder:
                        key = 'Cylinder';
                        break;
                    case SceneConstants.GeometryPrimitiveType.triangle:
                        key = 'Triangle';
                        break;
                    case SceneConstants.GeometryPrimitiveType.oval:
                        key = 'Oval';
                        break;
                    case SceneConstants.GeometryPrimitiveType.sphere:
                        key = 'Sphere';
                        break;
                    case SceneConstants.GeometryPrimitiveType.hood:
                        key = 'Hood';
                        break;
                    case SceneConstants.GeometryPrimitiveType.halfarc:
                        key = 'HalfArc';
                        break;
                }
                break;
            case SceneConstants.EntityType.TechnicalElement:
                switch ((this.tulipItem as TechnicalElement).objectId) {
                    case SceneConstants.TechnicalElementType.pole:
                        key = 'Pole';
                        break;
                    case SceneConstants.TechnicalElementType.boiler:
                        key = 'Boiler';
                        break;
                    case SceneConstants.TechnicalElementType.serviceShaft:
                        key = 'ServiceShaft';
                        break;
                    case SceneConstants.TechnicalElementType.fireplace:
                        key = 'Fireplace';
                        break;
                    case SceneConstants.TechnicalElementType.radiator:
                        key = 'Radiator';
                        break;
                    case SceneConstants.TechnicalElementType.airConditioner:
                        key = 'AirConditioner';
                        break;
                    case SceneConstants.TechnicalElementType.stove:
                        key = 'Stove';
                        break;
                    case SceneConstants.TechnicalElementType.waterSource:
                        key = 'WaterSource';
                        break;
                    case SceneConstants.TechnicalElementType.socketTV:
                        key = "SocketTV";
                        break;
                    case SceneConstants.TechnicalElementType.switchBoard:
                        key = "SwitchBoard";
                        break;
                    case SceneConstants.TechnicalElementType.socketSixteen:
                        key = "SocketSixteen";
                        break;
                    case SceneConstants.TechnicalElementType.socketThirtyTwo:
                        key = "SocketThirtyTwo";
                        break;
                    case SceneConstants.TechnicalElementType.wardRobe:
                        key = "WardRobe";
                        break;
                    case SceneConstants.TechnicalElementType.spotLight:
                        key = "SpotLight";
                        break;
                    case SceneConstants.TechnicalElementType.rosette:
                        key = "Rosette";
                        break;
                    case SceneConstants.TechnicalElementType.beam:
                        key = "Beam";
                        break;
                    case SceneConstants.TechnicalElementType.frame:
                        key = "Frame";
                        break;
                    case SceneConstants.TechnicalElementType.guardrail:
                        key = "GuardRail";
                        break;
                    case SceneConstants.TechnicalElementType.wallDecoration:
                        key = "WallDecoration";
                        break;
                }
                break;
            case SceneConstants.EntityType.Staircase:
                switch ((this.tulipItem as Staircase).objectId) {
                    case SceneConstants.StaircaseType.straight:
                        key = 'StraightStaircase';
                        break;
                    case SceneConstants.StaircaseType.quarterTurn:
                    case SceneConstants.StaircaseType.doubleQuarterTurn:
                        key = 'TurningStaircase';
                        break;
                    case SceneConstants.StaircaseType.circular:
                        key = 'SpiralStaircase';
                        break;
                }
                break;
        }
        return key;
    };
}